// language
export const SET_LANGUAGE = 'SET_LANGUAGE'

// errors
export const SET_ERRORS = 'SET_ERRORS'

// containers
export const SET_ALL_CONTAINERS = 'SET_ALL_CONTAINERS'
export const SET_SELECTED_CONTAINER = 'SET_SELECTED_CONTAINER'
export const SET_CONTAINER_PERMISSIONS = 'SET_CONTAINER_PERMISSIONS'

// booking collapse
export const SET_BOOKING_COLLAPSED = 'SET_BOOKING_COLLAPSED'
